
import { Card } from "@/components/ui/card";
import { ProductSubscriptionsChart } from "./ProductSubscriptionsChart";
import { PlanSubscriptionsCharts } from "./PlanSubscriptionsCharts";
import { SchoolSubscriptionsChart } from "./SchoolSubscriptionsChart";
import { ProductPlanChart } from "./ProductPlanChart";

interface StatData {
  label: string;
  value: number;
}

interface SubscriptionChartsProps {
  productSubscriptions: StatData[];
  planSubscriptions: StatData[];
  schoolSubscriptions: StatData[];
}

export const SubscriptionCharts = ({
  productSubscriptions,
  planSubscriptions,
  schoolSubscriptions,
}: SubscriptionChartsProps) => {
  const groupedPlanSubscriptions: { [key: string]: StatData[] } = {};
  
  // Process plan subscriptions to group by product
  planSubscriptions?.forEach((subscription) => {
    const [productName, planName] = subscription.label.split(' - ');
    if (!groupedPlanSubscriptions[productName]) {
      groupedPlanSubscriptions[productName] = [];
    }
    groupedPlanSubscriptions[productName].push({
      label: planName,
      value: subscription.value,
    });
  });

  return (
    <div className="space-y-8">
      {/* Main subscription charts */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
        <Card className="p-6">
          <h3 className="text-lg font-semibold mb-4">Product Subscriptions</h3>
          <ProductSubscriptionsChart data={productSubscriptions} />
        </Card>

        <SchoolSubscriptionsChart data={schoolSubscriptions} />
      </div>
      
      {/* Individual product plan charts */}
      <div className="mb-8">
        <h3 className="text-xl font-semibold mb-4">Product Plan Distribution</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {Object.entries(groupedPlanSubscriptions).map(([productName, plans]) => (
            <ProductPlanChart 
              key={productName}
              productName={productName}
              plans={plans}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
